import { render, staticRenderFns } from "./HuchaListadoAportaciones.vue?vue&type=template&id=0729a642&scoped=true"
import script from "./HuchaListadoAportaciones.vue?vue&type=script&lang=js"
export * from "./HuchaListadoAportaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0729a642",
  null
  
)

export default component.exports